import { Card } from '@siliconx/shared/ui/Card';
import { SectionLabel } from '@siliconx/shared/ui/SectionLabel';
import { RegulationChip } from './RegulationChip';
import { SCOPE3_EXCLUSIONS } from './scope3Copy';

/**
 * SIL-477 — Reports tab hosts the FULL Scope 3 exclusion-justification
 * register (sustainability-dashboard-spec.md §3 "Reports"), expanded rather
 * than the Overview tab's collapsed `<details>` footnote — this is the
 * register's authoritative home. Same `SCOPE3_EXCLUSIONS` data source as
 * Overview's `Scope3UpstreamDownstreamSection.tsx` (SIL-475) — never a
 * second copy of the justification strings. Removing the Overview
 * footnote once the Variant B category matrix ships is SIL-464's change,
 * not this ticket's.
 */
export function ScopeExclusionRegisterCard() {
  return (
    <Card padding="md" className="flex flex-col gap-3">
      <SectionLabel>Scope 3 exclusion register ({SCOPE3_EXCLUSIONS.length})</SectionLabel>
      <p className="text-xs leading-relaxed text-zinc-500">
        Every Scope 3 category judged out of scope, with the justification required by the GHG Protocol
        Scope 3 Standard&apos;s disclosure practice for excluded categories.
      </p>
      <ul className="flex flex-col gap-2.5">
        {SCOPE3_EXCLUSIONS.map((exclusion) => (
          <li
            key={exclusion.category}
            className="rounded-md border border-zinc-200 bg-zinc-50 p-3 text-xs leading-relaxed text-zinc-600"
            data-testid={`reports-exclusion-cat-${exclusion.category}`}
          >
            {exclusion.justification}
            {/* SIL-611: the disposal-of-retired-hardware sentence in Category
             * 5's justification is the only exclusion row that describes a
             * disposal/EOL flow — every other excluded category (travel,
             * commuting, investments, etc.) is unrelated to these
             * regulations, so no chip renders there. */}
            {exclusion.category === '5' && (
              <span className="ml-1.5 inline-block align-middle">
                <RegulationChip regulationKey="universal_waste_battery" />
              </span>
            )}
          </li>
        ))}
      </ul>
    </Card>
  );
}
